import { Header } from './components/Header'
import { ProductSection } from './components/ProductSection'
import { Footer } from './components/Footer'

export function HomePage() {
  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <Header />
      <main id="main">
        <section className="hero" aria-labelledby="hero-title">
          <img className="hero-image" src="/assets/images/hero-honey.jpg" alt="A jar of pure golden honey with honey dripping from a wooden dipper" />
          <div className="hero-overlay" />
          <div className="container hero-content">
            <p className="eyebrow">100% PURE • ONE HONEST INGREDIENT</p>
            <h1 id="hero-title">Pure honey.<br /><em>Just as nature intended.</em></h1>
            <p className="hero-copy">Nothing added. Nothing taken away. Only rich, golden honey with the natural taste you have been looking for.</p>
            <div className="hero-actions"><a className="button" href="#order">Taste the Difference</a><a className="text-link" href="#quality">Discover our promise →</a></div>
          </div>
        </section>

        <section className="promise" aria-label="The Alshifaa promise">
          <div className="container promise-grid"><p>One jar.<br /><strong>One pure ingredient.</strong></p><div className="promise-line" /><p className="promise-copy">A deep, naturally sweet taste and beautiful golden colour—created by bees and preserved with care.</p></div>
        </section>

        <section className="story section" id="story">
          <div className="container split-grid">
            <div className="image-frame"><img src="/assets/images/honey-story.jpg" alt="Pure honey, natural honeycomb and delicate flowers" loading="lazy" /></div>
            <div className="story-copy"><p className="eyebrow">THE ALSHIFAA STORY</p><h2>We protect what nature perfected.</h2><p>Great honey does not need improving. It only needs protecting. Alshifaa keeps things beautifully simple: carefully selected pure honey, bottled without unnecessary additives.</p><p>From the first golden pour to the final spoonful, every jar delivers the honest character of real honey.</p><div className="signature">Alshifaa <span>Pure Honey</span></div></div>
          </div>
        </section>

        <section className="quality section" id="quality">
          <div className="container">
            <div className="section-heading"><p className="eyebrow">WHAT IS INSIDE?</p><h2>Honey. That is all.</h2></div>
            <div className="quality-grid">
              <article className="quality-card"><span>01</span><h3>100% Pure</h3><p>No added sugar, artificial sweeteners or unnecessary ingredients.</p></article>
              <article className="quality-card"><span>02</span><h3>Naturally Delicious</h3><p>The authentic aroma, colour and flavour of real honey are beautifully preserved.</p></article>
              <article className="quality-card"><span>03</span><h3>Handled with Care</h3><p>Thoughtfully prepared and bottled so every spoonful feels worth savouring.</p></article>
            </div>
          </div>
        </section>

        <ProductSection />

        <section className="quote-section"><div className="container"><blockquote>“Purity you can taste.”</blockquote><p>ALSHIFAA HONEY</p></div></section>
      </main>
      <Footer />
    </>
  )
}
